<template>
  <div class="type_number" :class="{ loading }">
    <div class="loading_spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="value">{{ value }}</div>
    <div class="title">
      {{ declOfNum(value, ["Номер", "Номера", "Номеров"]) }} в FindGuest
    </div>
  </div>
</template>

<script>
let apiDriver = require("../../apiDriver").default;
let moment = require("moment");

export default {
  name: "service_3_guestsCount",
  data: function () {
    return {
      loading: true,
      value: 0,
    };
  },
  methods: {
    declOfNum: function (number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    getData: async function () {
      this.loading = true;
      let x = (await apiDriver.services.api.get("findguest", "my_clients"))
        .data;
      this.value = x.clients_count;
      this.loading = false;
    },
  },
  mounted: function () {
    this.getData();
  },
};
</script>